import React from 'react';
import { HighlightTextField } from './HighlightTextField.styles';

interface DescriptionFieldProps {
  value: string;
  onChange: (value: string) => void;
  isSelected: boolean;
  onClick: () => void;
  error?: boolean;
  helperText?: string;
}

export const DescriptionField: React.FC<DescriptionFieldProps> = ({
  value,
  onChange,
  isSelected,
  onClick,
  error = false,
  helperText = '',
}) => {
  return (
    <HighlightTextField
      highlighted={isSelected}
      label="Description"
      value={value}
      onChange={e => onChange(e.target.value)}
      onClick={onClick}
      variant="outlined"
      fullWidth
      required
      multiline
      rows={2}
      error={error}
      helperText={helperText}
      sx={{ '& .MuiOutlinedInput-input': { minHeight: '40px !important' } }}
    />
  );
};
